export default {
  BROADCASTED: 'Broadcasted',
  RECEIPT: 'Receipt',
  FAILED: 'Failed',
  NOT_BROADCASTED: 'NotBroadcasted',
  VERIFY_PAGE_SHOWN: 'VerifyPageShown',
  CANCELLED: 'Cancelled',
  SUCCESS: 'Success',
  CONFIRM_CLICKED: 'ConfirmClicked',
  FIELD_INPUTS: 'FieldInputs',
  NEXT_CLICKED: 'NextClicked',
  INITIAL_MODAL_CLOSED: 'InitiatedModalClosed',
  SWAP_INITIATED: 'SwapInitiated',
  TRANSACTION_INITIATIED: 'TransactionInitiated',
  X_OUT: 'XOut',
  CLICK_OUTSIDE: 'ClickOutside',
  BUTTON_CANCEL: 'ButtonCancel'
};
